  
// Set the date we're counting down to
//var lastorderdate = customer.last_order;
var lastorderdate = new Date("09/17/2020");
var nextavailabledate = lastorderdate.setMonth(lastorderdate.getMonth() + 24); 
var countDownDate = new Date(nextavailabledate).getTime();
  
// Update the count down every 1 second
 var x = setInterval(function() {
   
// Get today's date and time
var now = new Date().getTime();
   
// Find the distance between now and the count down date
var remainingtime = countDownDate - now;   
   
// Time calculations for days, hours, minutes and seconds
var days = Math.floor(remainingtime / (1000 * 60 * 60 * 24));
var hours = Math.floor((remainingtime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
var minutes = Math.floor((remainingtime % (1000 * 60 * 60)) / (1000 * 60));
var seconds = Math.floor((remainingtime % (1000 * 60)) / 1000);    
   
// Output the result in an element with id="demo"
   if(document.getElementById("remainingtime") != null){  
   		document.getElementById("remainingtime").innerHTML = "Your remaining time is" + " " + days + "d " + hours + "h " + minutes + "m " + seconds + "s ";    
   }  
}, 1000);

// to display an error message if the quantity exceeds certain value
  
/*function myFunction() {
  var message = "";
  if (document.getElementById("Quantity").validity.rangeOverflow)
  {
    message = "*The quantity cannot be greater than 1";
    document.getElementById("alert").innerHTML = message;
  }      
}
  
function myFunctionmax() {
  var message = "";
  if (document.getElementById("QuantityExcpetion").validity.rangeOverflow){
    message = "*The quantity cannot be greater than 5";
  }
  document.getElementById("alert").innerHTML = message;
} */

// disbaling the add to cart button on submitting

function submitAndDisable(btnId){
  document.getElementById("AddToCartForm-product-template").submit();
  document.getElementById(btnId).setAttribute('disabled', true);
}

// disabling the add to cart button (non-exception) while overlooking the quantity check by manual inputing 

function checkquantity(){
var nonexmaxqty = document.getElementById("Quantity").max;
var parseIntnonexmaxqty = parseInt(nonexmaxqty);
var qtyval =  document.getElementById("Quantity").value;
var parseIntqtyval = parseInt(qtyval);
var isVIP = document.getElementById('VIP').getAttribute("data-val");
var message = "*The quantity cannot be greater than 1";
var messageVIP = "*The quantity cannot be greater than" + " " +(nonexmaxqty);
var btnId = "AddToCart-product-template";
//console.log(qtyval);
//console.log(nonexmaxqty);
if (parseIntqtyval > parseIntnonexmaxqty)
{
  document.getElementById(btnId).setAttribute('disabled', true);
  document.getElementById('SingleOptionSelector-0').disabled = true;
  if (isVIP)
  {
    document.getElementById("alert").innerHTML = messageVIP;
  }
  else
  {
    document.getElementById("alert").innerHTML = message;
  }
}
else 
{
 document.getElementById(btnId).disabled = false;
 document.getElementById('SingleOptionSelector-0').disabled = false;
 document.getElementById("alert").innerHTML = null;
}
}

// disabling the add to cart button (exception) while overlooking the quantity check by manual inputing 

function excepcheckquantity(){
var nonexmaxqty = document.getElementById("QuantityExcpetion").max;
var parseIntnonexmaxqty = parseInt(nonexmaxqty);
var qtyval =  document.getElementById("QuantityExcpetion").value;
var parseIntqtyval = parseInt(qtyval);
var message = "*The quantity cannot be greater than" + " " +(nonexmaxqty);
var btnId = "AddToCart-product-template";
//console.log(qtyval);
//console.log(nonexmaxqty);
if (parseIntqtyval > parseIntnonexmaxqty)
{
  document.getElementById(btnId).setAttribute('disabled', true);
  document.getElementById('SingleOptionSelector-0').disabled = true;
  document.getElementById("alert").innerHTML = message;
}
else 
{
 document.getElementById(btnId).disabled = false;
 document.getElementById('SingleOptionSelector-0').disabled = false;
 document.getElementById("alert").innerHTML = null;
}
}
  

  
